import React from 'react';

interface ToggleRowProps {
  label: string;
  sub?: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (next: boolean) => void;
}

function ToggleRow({ label, sub, checked, disabled, onChange }: ToggleRowProps) {
  return (
    <div className="toggle-row">
      <div className="toggle-info">
        <div className="toggle-label">{label}</div>
        {sub && <div className="toggle-sub">{sub}</div>}
      </div>
      <div
        className={`toggle ${checked ? 'on' : ''}${disabled ? ' disabled' : ''}`}
        onClick={() => !disabled && onChange(!checked)}
      />
    </div>
  );
}

export default ToggleRow;
